
const contextUrl = window.location.hostname

export default contextUrl



// WEBPACK FOOTER //
// ./src/App/Root/contextUrl.js